import React from 'react';
import PropTypes from 'prop-types';
import { COLORS, TYPOGRAPHY } from '../../../styles/UISystem';
import IconCaretRight from '../../UISystem/Icons/IconCaretRight';

/**
 * ContactShareMessage Component
 *
 * Displays a contact sharing message with:
 * - Circle with first initial of the name
 * - Name text
 * - Caret right icon
 *
 * Used in chat bubbles when a user shares their contact information
 */
export const ContactShareMessage = ({ name, isSent = true, onClick = null }) => {
  // Get first character of name for initial (uppercase)
  const initial = name && name.length > 0 ? name.charAt(0).toUpperCase() : '';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        gap: '12px', // Space between elements
        padding: '2px 0', // Add a bit of padding for better click target
      }}
      onClick={onClick}
    >
      {/* Circle with initial */}
      <div
        style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          backgroundColor: isSent ? COLORS.WHITE : COLORS.MEDIUM_GRAY,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            ...TYPOGRAPHY.BODY_REGULAR,
            fontWeight: '500',
            color: isSent ? COLORS.MEDIUM_BLUE : COLORS.WHITE,
          }}
        >
          {initial}
        </div>
      </div>

      {/* Name text */}
      <div
        style={{
          ...TYPOGRAPHY.BODY_REGULAR,
          color: isSent ? COLORS.WHITE : COLORS.DARK_GRAY,
          flexGrow: 1,
        }}
      >
        {name}
      </div>

      {/* Caret right icon */}
      <IconCaretRight
        fill={isSent ? COLORS.WHITE : COLORS.DARK_GRAY}
        style={{
          width: '16px',
          height: '16px',
        }}
      />
    </div>
  );
};

ContactShareMessage.propTypes = {
  /** Name of the contact being shared */
  name: PropTypes.string.isRequired,
  /** Whether the message is sent (blue background) or received (gray background) */
  isSent: PropTypes.bool,
  /** Callback function when clicked */
  onClick: PropTypes.func,
};
